// extracted by mini-css-extract-plugin
export default {"unstuddable-image":"unstuddable-image__unstuddable-image___3ULis"};